var _circle, _circle2, _path, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSmileys = function SvgSmileys(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 10,
    r: 1,
    fill: "#7A7359"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 10,
    r: 1,
    fill: "#7A7359"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#7A7359",
    strokeLinecap: "round",
    d: "M15 14.5a4.243 4.243 0 0 1-6 0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 7.5,
    stroke: "#7A7359",
    strokeLinecap: "round"
  })));
};
export { SvgSmileys as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9Im5vbmUiPjxjaXJjbGUgY3g9IjkuNSIgY3k9IjEwIiByPSIxIiBmaWxsPSIjN0E3MzU5Ii8+PGNpcmNsZSBjeD0iMTQuNSIgY3k9IjEwIiByPSIxIiBmaWxsPSIjN0E3MzU5Ii8+PHBhdGggc3Ryb2tlPSIjN0E3MzU5IiBzdHJva2UtbGluZWNhcD0icm91bmQiIGQ9Ik0xNSAxNC41YTQuMjQzIDQuMjQzIDAgMCAxLTYgMCIvPjxjaXJjbGUgY3g9IjEyIiBjeT0iMTIiIHI9IjcuNSIgc3Ryb2tlPSIjN0E3MzU5IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz48L3N2Zz4=";